import { Injectable } from '@angular/core';
import { StorageService } from '@platform-frontend/util';
import { ModalData } from './modal-data';
import { ModalReloadData } from './modal-reload-data';

@Injectable({
  providedIn: 'root'
})
export class ModalReloadDataService {
  constructor(private storageService: StorageService) {}

  private readonly MODAL_RELOAD_DATA_STORAGE = 'yattaModal';

  getReloadData(): ModalReloadData | null {
    return this.storageService.getFromSessionStorage<ModalReloadData>(this.MODAL_RELOAD_DATA_STORAGE);
  }

  setReloadData(identifier: symbol, data: ModalData, isClosable: boolean): void {
    const modalReloadData: ModalReloadData = {
      data,
      identifier: identifier.toString(),
      isClosable
    };
    this.storageService.putInSessionStorage(this.MODAL_RELOAD_DATA_STORAGE, modalReloadData);
  }

  clearReloadData(): void {
    this.storageService.removeFromSessionStorage(this.MODAL_RELOAD_DATA_STORAGE);
  }
}
